import styled from '@emotion/styled';

export const FormContainer = styled.div`
	.icon-container {
		&.col {
			.formitem-column {
				flex-direction: column;
				gap: 2rem;
			}
		}
		&.row {
			.formitem-column {
				flex-direction: row;
				gap: 2rem;
			}
		}
	}
	.pre-text {
		font-family: inherit;
		margin: 0;
	}
	.json-text-area {
		max-width: 100%;
		min-width: 100%;
		max-height: 30rem;
		min-height: 4.5rem;
	}
`;

export const FormSubHeader = styled.div`
	display: flex;
	flex-direction: column;
	flex: 0 0 auto;
	width: 100%;
	padding: var(--padding-2);
	gap: 1rem;
	&::after {
		content: '';
		height: 1px;
		background-color: var(--border-color);
	}
`;

export const StatusMappingContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
`;

export const NoRecordsFound = styled.div`
	display: flex;
	justify-content: center;
	padding: 2rem 0;
`;
